module.exports = __webpack_public_path__ + "img/dgjg-login.ec44f7a3.svg";